<template>
  <v-main>
    <v-container class="fill-height" fluid style="background-color: #ccc" v-if="!this.$store.getters.isAuthen">
      <v-row no-gutters align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-row align="center" justify="center">
            <v-col cols="12" align="center">
              <div style="font-size: 28px"><b>TAI</b>-Intranet</div>
              <div style="font-size: 14px">Ver:2.538.0 Build:20251219.094451</div>
            </v-col>
          </v-row>
          <v-card class="elevation-12" v-if="!$store.getters.isAuthen || true">
            <v-toolbar color="primary" dark flat v-if="false">
              <v-toolbar-title>SignIn </v-toolbar-title>
              <v-spacer />
              <!-- <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    :href="source"
                    icon
                    large
                    target="_blank"
                    v-on="on"
                  >
                    <v-icon>mdi-code-tags</v-icon>
                  </v-btn>
                </template>
                <span>Source</span>
              </v-tooltip>
              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    large
                    href="https://codepen.io/johnjleider/pen/pMvGQO"
                    target="_blank"
                    v-on="on"
                  >
                    <v-icon>mdi-codepen</v-icon>
                  </v-btn>
                </template>
                <span>Codepen</span>
              </v-tooltip> -->
            </v-toolbar>
            <v-card-text>
              <div align="center">
                <!-- <v-avatar size="120px"> -->
                <img height="60" :src="staticPath + 'logo_tai.jpg'" />
                <!-- <br/><br/> -->
                <!-- <p>โปรดกรอก ชื่อผู้ใช้ และ รหัสผ่าน<br> -->
                <!-- <span style="font-size:12px;color:#252525">(โดยใช้ชุดเดียวกันกับตอนล็อกอินบนเครื่องคอมพิวเตอร์ที่<br>สถาบันยานยนต์)</span> -->
                <!-- </p> -->
                <!-- </v-avatar> -->
              </div>
              <v-form v-model="valid" ref="form">
                <v-text-field
                  ref="username"
                  label="Username"
                  prepend-inner-icon="mdi-account"
                  class="my-5"
                  hint="ใช้ Username เดียวกันกับตอน login เข้าเครื่องคอมพิวเตอร์ที่สถาบันยานยนต์"
                  v-model="user.username"
                  :rules="nameRules"
                  @keyup.enter="$refs.password.focus()"
                  autofocus
                  required
                  :disabled="ok"
                ></v-text-field>
                <v-text-field
                  ref="password"
                  label="Password"
                  :prepend-inner-icon="showpass ? 'mdi-form-textbox-password' : 'mdi-lock'"
                  hint=""
                  v-model="user.password"
                  :rules="passwordRules"
                  @keyup.enter="signIn"
                  :append-icon="showpass ? 'mdi-eye-off' : 'mdi-eye'"
                  :type="showpass ? 'text' : 'password'"
                  @click:append="showpass = !showpass"
                  required
                  :disabled="ok"
                ></v-text-field>
              </v-form>
              <v-alert v-if="error !== ''" outline color="error" icon="warning" :value="true">
                {{ error }}
              </v-alert>
              <v-alert type="warning" :value="$browserDetect.isIE"> กรุณาเปิดด้วย Chrome หรือ Firefox หรือ Safari </v-alert>
            </v-card-text>
            <v-progress-linear v-bind:indeterminate="true" v-if="ok"></v-progress-linear>
            <v-card-actions>
              <v-spacer />
              <!-- <v-btn color="primary" @click="authen">Login</v-btn> -->
              <v-btn @click="signIn" :disabled="ok" :class="{ primary: valid, error: !valid }">Sign In</v-btn>
              <v-btn @click="clear">clear</v-btn>
            </v-card-actions>
          </v-card>
          <!-- <v-alert color="error" class="white--text">{{$browserDetect}}หมายเหตุ : กรุณากด Ctrl+F5 เพื่อรับ Version ใหม่ของโปรแกรม</v-alert> -->
          <v-card v-if="$store.getters.isAuthen && false">
            <v-toolbar class="primary" dark dense flat>
              <v-toolbar-title>ลงชื่อออกจากระบบ</v-toolbar-title>
            </v-toolbar>
            <v-img :src="$store.state.rootPath + 'static/Logo_TAI.jpg'" height="90px" contain> </v-img>
            <v-card-title primary-title>
              <div>
                <h3 class="headline mb-0">
                  {{ $store.state.users.main.FullName }}
                </h3>
                <div>{{ $store.state.users.main.Department }}<br />{{ $store.state.users.main.Division }}</div>
              </div>
            </v-card-title>
            <v-card-actions>
              <v-btn text class="blue--text" @click="signOut">signOut</v-btn>
            </v-card-actions>
          </v-card>
          <br /><br />
          <div class="lockscreen-footer text-center">
            Copyright © 2019
            <b
              ><a href="#" class="text-black"><b>TAI</b>-Intranet</a></b
            ><br />
            All rights reserved
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import { mapActions } from 'vuex'
import bookServ from '@/store/api/services/bookService'
// import browserDetect from 'vue-browser-detect-plugin'

export default {
  name: 'login',
  // components:{
  //   browserDetect
  // },
  data() {
    return {
      showpass: false,
      version: '2.538.0',
      apiPath: process.env.VUE_APP_API_PATH.replace('//localhost', window.location.protocol + '//' + window.location.host.split(':')[0]),
      staticPath: process.env.VUE_APP_STATIC.replace('//localhost', window.location.protocol + '//' + window.location.host.split(':')[0]),
      user: {
        username: '',
        password: '',
        version: '2.538.0'
      },
      redirect: '',
      valid: false,
      ok: false,
      error: '',
      browser: '',

      nameRules: [(v) => !!v || 'กรุณาใส่ UserName', (v) => v.length >= 3 || 'ชื่อต้องไม่น้อยกว่า 3 ตัวอักษร'],
      passwordRules: [(v) => !!v || 'กรุณาใส่ Password', (v) => v.length >= 6 || 'ชื่อต้องไม่น้อยกว่า 6 ตัวอักษร']
    }
  },
  beforeCreate() {
    if (this.$store.getters.isAuthen) {
      this.$router.push('/')
    }
  },
  mounted() {
    // browser = $browserDetect
    console.log('browser', this.browser)
    console.log('process.env', process.env)
    window.localStorage.clear()
    localStorage.setItem('isoList-pagination', '')
    localStorage.setItem('isoList-process', '')
    localStorage.setItem('isoList-filter', '')
    localStorage.setItem('vuex', '')
    localStorage.setItem('EmpAll', '')
  },
  methods: {
    ...mapActions(['signIn']),
    clear() {
      this.user.username = ''
      this.user.password = ''
      this.ok = false
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.signIn()
      }
    },
    async signIn() {
      if (this.valid) {
        this.ok = true
        this.error = ''

        this.redirect = ''
        await this.$store.dispatch('signIn', this.user)
        try {
          console.log('authen', this.$store.getters)
          if (this.$store.getters.isAuthen) {
            if (this.$route.query.redirect) {
              // this.$router.push(this.$route.query.redirect)
              this.redirect = this.$route.query.redirect
              let url = ''
              let data = this.$route.query
              Object.keys(data).forEach(function(key) {
                if(key !== 'redirect'){
                  url += "&" + key + '=' + data[key]
                }
                // console.log('Key : ' + key + ', Value : ' + data[key])
              })
              if (url !== ''){
                this.redirect += '?redirect=' + url
              }
            } else if (this.$route.params.id !== '' && this.$route.params.id !== undefined) {
              // this.$router.push('/bookviewedit/' + this.$route.params.id)
              this.redirect = '/bookviewedit/' + this.$route.params.id
            } else if (this.$route.params.itemCode !== '' && this.$route.params.itemCode !== undefined) {
              // this.$router.push('/itiso/add/' + this.$route.params.itemCode + '/' + this.$route.params.bYear)
              this.redirect = '/itiso/add/' + this.$route.params.itemCode
            } else if (this.$route.params.ReqCode !== '' && this.$route.params.ReqCode !== undefined) {
              // this.$router.push('/itiso/edit/' + this.$route.params.ReqCode + '/' + this.$route.params.bYear)
              this.redirect = '/itiso/edit/' + this.$route.params.ReqCode
            } else {
              this.redirect = '/'
            }
            if (this.$route.params.bYear !== '' && this.$route.params.bYear !== undefined) {
              this.redirect += '/' + this.$route.params.bYear
            }
            // this.$router.push('/')
            let response

            response = await bookServ.getNotificate(this.$store.state.users.main)
            this.$store.commit('setNotificate', response.data.data)

            response = await bookServ.getEmp(this.$store.state.users.main)
            this.$store.commit('setPersons', response.data.data)
            localStorage.setItem('persons', JSON.stringify(this.$store.state.users.persons))

            response = await bookServ.getDep(this.$store.state.users.main)
            this.$store.commit('setDep', response.data.data)

            response = await bookServ.getPermission(this.$store.state.users.main)
            this.$store.commit('setPermission', response.data.data)

            // this.$store.dispatch("getEmpAll");
            // this.$store.dispatch('prloadHistory')
            // this.$store.dispatch('prCurrentStatus')
            // this.$store.dispatch('prUnit')
            // this.$store.dispatch('prItemSpec')
            // this.$store.dispatch('prConfig')
            // this.$store.dispatch("prListCount");
            // this.$store.dispatch('tscLoadHistory')

            this.$router.push(this.redirect)
          } else {
            this.ok = false
            this.error = 'Sign In Error'
          }
        } catch (error) {
          console.log('Show error notification!', 'Something wrong')
          this.ok = false
          this.error = 'Something wrong'
        }
      }
    },
    signOut() {
      this.$store.dispatch('signOut')
      this.$router.push('/signin')
    }
  }
}
</script>

<style scoped></style>
